import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/common/Layout'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import MyPage from './pages/MyPage'
import Search from './pages/Search'
import Collection from './pages/Collection'
import CollectionAdd from './pages/CollectionAdd'
import CollectionDetail from './pages/CollectionDetail'
import CollectionEdit from './pages/CollectionEdit'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="search" element={<Search />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="mypage" element={<MyPage />} />
          <Route path="collection" element={<Collection />} />
          <Route path="collection/add" element={<CollectionAdd />} />
          <Route path="collection/:id" element={<CollectionDetail />} />
          <Route path="collection/:id/edit" element={<CollectionEdit />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
